<kui-modal #modal [loading]="loading" [title]="'ANALYTICS.CREATE_WIDGET.SHARE_TO_DASHBOARD' | translate" [actions]="modalActions" (onClose)="detachModal()">
    @if (errorMessage) {
        <kui-alert type="danger" class="mb-0 key-alert-wrapper">
            <kui-icon name="ban" size="sm"></kui-icon>
            <span>{{ errorMessage }}</span>
        </kui-alert>
    }

    @if (success) {
        <div class="p-4">
            {{
                "ANALYTICS.CREATE_WIDGET.SUCCESSFULL_MESSAGE"
                    | translate
                        : {
                              dashboards: getDashboardsString(formValues.shareType === "template" ? formValues.templates : formValues.dashboards),
                          }
            }}
        </div>
    } @else {
        <div class="p-4 border-bottom">
            <div class="d-flex" style="min-height: 200px">
                @if (!noResult) {
                    <key-analytics-chart [cellset]="cellset" [settings]="settings" [type]="widgetType"></key-analytics-chart>
                }
                @if (noResult) {
                    <kui-alert-panel [message]="'ANALYTICS.ERRORS.NO_RESULTS' | translate"></kui-alert-panel>
                }
            </div>
        </div>
        <div class="p-4">
            <key-form-builder [form]="form" [values]="formValues" (onChange)="onFormChanges($event)" autoTranslatePrefix="ANALYTICS.CREATE_WIDGET"></key-form-builder>
        </div>
    }
</kui-modal>
